module.exports = __webpack_public_path__ + "img/1.67fa3c82.png";